import { defineComponent as _defineComponent } from 'vue'
import { ref, toRefs, computed, onMounted } from 'vue';
import DropFile from '@/components/base/DropFile.vue';
import type { MaterialWithTmpFile } from '@/resources/materials/types';

type Emits = {
  (e: 'save', f: File): void;
};
type Props = {
  material: MaterialWithTmpFile;
  imgSize?: number[];
  isLoading?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewImageDialog',
  props: {
    material: null,
    imgSize: { default: () => [794, 1123] },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save', f: File): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { material: MaterialWithTmpFile, imgSize: number[], isLoading: boolean }




const { material, isLoading } = toRefs(props);

const dialog = ref(false);
const previewUrl = ref('');
const isChanged = ref(false);

const hasPreviewUrl = computed(() => !!previewUrl.value);
const isTemplate = computed(() => !material?.value?.id);

const getPreviewUrl = async (id: string) => {
  const cfUrl = process.env.VUE_APP_COVERS_DOMAIN;
  const response = await fetch(`https://${cfUrl}/public/materialPreviews/${id}/preview.png?height=100`);
  if (response.ok) {
    previewUrl.value = `https://${cfUrl}/public/materialPreviews/${id}/preview.png?height=600`;
  }
};

const onImgChange = async (inputFiles: File[]) => {
  if (!inputFiles || !inputFiles.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  const imageFile = inputFiles[0];
  const image = new Image();
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const desiredWidth = props.imgSize[0]; // desired width
  const desiredHeight = props.imgSize[1]; // desired height

  image.onload = () => {
    canvas.width = desiredWidth;
    canvas.height = desiredHeight;

    const offsetX = (image.width - desiredWidth) / 2;
    const offsetY = (image.height - desiredHeight) / 2;

    ctx?.drawImage(image, offsetX, offsetY, desiredWidth, desiredHeight, 0, 0, desiredWidth, desiredHeight);

    canvas.toBlob((blob) => {
      if (blob) {
        const croppedFile = new File([blob], imageFile.name, { type: imageFile.type });
        previewUrl.value = URL.createObjectURL(croppedFile);
        emit('save', croppedFile);
      }
    }, imageFile.type);
  };

  image.src = URL.createObjectURL(imageFile);
  console.debug('Image file', image);
  dialog.value = false;
};

onMounted(async () => {
  if (material?.value?.id) {
    await getPreviewUrl(material.value.id);
  }
});

return { __sfc: true,emit, props, material, isLoading, dialog, previewUrl, isChanged, hasPreviewUrl, isTemplate, getPreviewUrl, onImgChange, DropFile }
}

})